export default class PageToolBase {
    onPointerDown(e) { };
    onPointerMove(e) { };
    onPointerUp(e) { };
}